// web interaction
const GET_MENU = "GET_MENU";
const THUMBS_UP = "THUMBS_UP";

// local state change
const ADD_CART = "ADD_CART";

export function addMenu(content){
  return {
    type: GET_MENU,
    payload: content
  }
};

export function thumbsUpAction(content){
  return {
    type: THUMBS_UP,
    payload: content
  }
};

export function AddCart(content) {
  return {
    type: ADD_CART,
    payload: content
  }
}